var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInstagram = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M5.067.727h5.906c2.387 0 4.38 1.926 4.38 4.313v5.907c0 2.386-1.993 4.38-4.38 4.38H5.067c-2.387 0-4.314-1.994-4.314-4.38V5.04A4.31 4.31 0 0 1 5.067.727M11.04 13.8a2.83 2.83 0 0 0 2.853-2.853V5.04a2.83 2.83 0 0 0-2.853-2.853H5.067A2.83 2.83 0 0 0 2.213 5.04v5.907A2.83 2.83 0 0 0 5.067 13.8z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M4.273 8.027c0-2.12 1.72-3.78 3.78-3.78a3.777 3.777 0 0 1 3.78 3.78 3.78 3.78 0 0 1-3.78 3.786 3.78 3.78 0 0 1-3.78-3.786m1.454-.007c0 1.267 1.066 2.327 2.326 2.327s2.32-1.06 2.327-2.327c0-1.26-1.06-2.32-2.327-2.32S5.727 6.76 5.727 8.02",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.7 4.246c0 .534-.4.927-.927.927a.91.91 0 0 1-.926-.927c0-.533.4-.926.926-.926.527.06.927.46.927.926"
})));
export default SvgInstagram;